import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const submitIntake = (data) => api.post("/intake", data).then((r) => r.data);
export const submitContact = (data) => api.post("/contact", data).then((r) => r.data);
export const getAvailability = () => api.get("/availability").then((r) => r.data);

export const verifyAdmin = (passcode) =>
  api.post("/admin/verify", { passcode }).then((r) => r.data);

const adminHeaders = (key) => ({ headers: { "x-admin-key": key } });

export const getIntakes = (key) => api.get("/intake", adminHeaders(key)).then((r) => r.data);
export const getContacts = (key) => api.get("/contact", adminHeaders(key)).then((r) => r.data);
export const getStats = (key) => api.get("/stats", adminHeaders(key)).then((r) => r.data);
export const updateStatus = (key, id, status) =>
  api.patch(`/intake/${id}/status`, { status }, adminHeaders(key)).then((r) => r.data);
